import { useDeleteTimeEntryMutation } from "@common/api/time-entries"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute("/_layout/timesheet/delete/$timeEntryId")({
  component: DeleteTimeEntryDialog,
})

function DeleteTimeEntryDialog(): React.ReactElement {
  const { timeEntryId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const mutation = useDeleteTimeEntryMutation()
  const close = () => navigate({ to: "/timesheet", search: true })

  return (
    <ConfirmDialog
      title="Archive this time entry?"
      description="Its hours come off your timesheet."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={mutation.isPending}
      onCancel={close}
      onConfirm={() =>
        mutation.mutate(
          { time_entry_id: timeEntryId },
          {
            onSuccess: () => {
              showToast("Time entry archived", "", "success")
              close()
            },
            onError: (err) => handleError(err, showToast),
          },
        )
      }
    />
  )
}
